import React from 'react';
import { Box, Paper, Typography, Button, IconButton } from '@mui/material';
import { LocationOn, Close } from '@mui/icons-material';

const MapModal = ({ open, onClose, onOpenMap }) => {
  if (!open) return null;

  return (
    <Box sx={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 9999,
      display: 'flex', justifyContent: 'center', alignItems: 'center', px: 2
    }}>
      <Paper sx={{ padding: '24px 20px', width: '100%', maxWidth: 340, textAlign: 'center', borderRadius: '16px', position: 'relative', boxShadow: '0px 4px 20px rgba(0,0,0,0.15)' }}>
        
        <IconButton onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8, color: '#999' }}>
          <Close />
        </IconButton>

        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Box sx={{ width: 60, height: 60, borderRadius: '50%', backgroundColor: '#FFF0E5', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <LocationOn sx={{ color: '#8B4513', fontSize: 32 }} />
          </Box>
        </Box>

        <Typography variant="h6" sx={{ fontWeight: 700, color: '#333', mb: 1 }}>
          Your Details Have Been Shared
        </Typography>
        <Typography variant="body2" sx={{ color: '#666', mb: 2 }}>
          Your contact details have been sent to the owner. You can now view the property location on map.
        </Typography>

        {/* Map Preview Image */}
        <Box sx={{ width: '100%', height: 100, borderRadius: '12px', mb: 2, overflow: 'hidden', position: 'relative', backgroundImage: 'url(https://maps.googleapis.com/maps/api/staticmap?center=17.3850,78.4867&zoom=13&size=400x200&maptype=roadmap)', backgroundSize: 'cover' }}>
           <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center' }}>
              <LocationOn sx={{ color: 'red', fontSize: 30 }} />
              <Typography variant="caption" sx={{ display: 'block', bgcolor: 'white', px: 0.5, borderRadius: 1, fontSize: '10px', fontWeight: 'bold' }}>
                Property Location
              </Typography>
           </Box>
        </Box>

        <Button 
          fullWidth variant="contained" onClick={onOpenMap}
          startIcon={<LocationOn />}
          sx={{ backgroundColor: '#8B4513', color: '#fff', borderRadius: '8px', textTransform: 'none', fontSize: '16px', fontWeight: 600, py: 1.2, '&:hover': { backgroundColor: '#703610' } }}
        >
          Open Map
        </Button>
      </Paper>
    </Box>
  );
};

export default MapModal;